import { render, staticRenderFns } from "./DSAboutPage.vue?vue&type=template&id=674a7299&scoped=true&"
import script from "./DSAboutPage.vue?vue&type=script&lang=ts&"
export * from "./DSAboutPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674a7299",
  null
  
)

export default component.exports